module.exports = __webpack_public_path__ + "static/assets/53d7e392dc0f35620dc77321555a936e.gif";